const s = {
  sm: "xs",
  md: "xs",
  lg: "xs"
}, E = {
  sm: 4,
  md: 8,
  lg: 12
};
export {
  s as FOOTER_BUTTON_SIZE,
  E as FOOTER_SPACE_SIZE
};
//# sourceMappingURL=highrise.es286.js.map
